'use strict';

const config = {
    triggerSelector: '.js-on-click-confirm'
};

$(config.triggerSelector).click(function() {
    const message = $(this).data('message');
    return confirm(message);
});



// WEBPACK FOOTER //
// ./src/js/components/on-click-confirm.js